export default "<template>\n    <section>\n        <o-datetimepicker inline />\n    </section>\n</template>\n"